export default __webpack_public_path__ + "static/qawhat-5-abb4370a76326d1b6e30d6ec6e701e52.png";